import { Button, Dropdown } from "antd";
import { useEffect, useMemo, useState } from "react";
import { IoIosMore } from "react-icons/io";
import { IoChevronDown, IoChevronUp, IoClose } from "react-icons/io5";
import { RxDrawingPinFilled } from "react-icons/rx";
import { TbArrowBigUpLines } from "react-icons/tb";
import apiFactory from "../../../api";
import ImageDisplay from "../../../components/chat/ImageDisplay";
import { PreviewFile } from "../../../components/chat/PreviewFile";
import { MESSAGE_STATUS } from "../../../config/Constant";
import { useMenuContext } from "../../../context/MenuContext";
import { useInfoUser } from "../../../store/UserStore";
import {
  openNotificationError,
  pinnedMessage,
  truncateText,
} from "../../../utils/Utils";
import "./style.scss";
import { useChatContext } from "../../../context/ChatContext";

const PinContent = ({ pinData }) => {
  if (pinData?.contentType === MESSAGE_STATUS.FILE) {
    return (
      <PreviewFile
        isPinned={true}
        requestUuid={pinData?.messageId}
        content={pinData?.content}
        file={pinData?.file}
        contentType={pinData?.contentType}
        percentProgress={0}
        totalVolume={pinData?.totalVolume}
      />
    );
  }

  if (pinData?.contentType === MESSAGE_STATUS.IMAGE) {
    return (
      <div className="flex items-center">
        <ImageDisplay
          minioPath={pinData?.photo?.thumbnailPreviewPath}
          classNameCss={
            "max-w-full max-h-40 rounded-md mb-1 mr-[4px] pinned-img"
          }
        />
        <div className="text-[12px] text-gray-600 truncate w-[70%]">
          {truncateText(pinData?.content, 150) || "[Image]"}
        </div>
      </div>
    );
  }

  if (
    pinData?.contentType === MESSAGE_STATUS.TEXT &&
    pinData?.previewLink?.image
  )
    <div className="flex items-center">
      <img
        src={pinData?.previewLink?.image}
        alt="preview"
        className="max-w-[40px] max-h-40 rounded-md mb-1 mr-[4px] pinned-img"
      />
      <p>{truncateText(pinData?.content, 150) || "Image"}</p>
    </div>;

  return truncateText(pinData?.content, 150) || "...";
};

const PinAction = ({ index, pinData, onPromote, unPinMessage, isNotice }) => {
  const { pinnedMessages, showAllPin, setShowAllPin } = useChatContext();
  const { languageMap } = useInfoUser();

  const onMenuClick = ({ key }) => {
    switch (key) {
      case "unpin":
        unPinMessage(pinData);
        break;
      case "promote":
        onPromote(pinData);
        break;
      default:
        console.log("no action");
    }
  };

  const dropDownItemList = useMemo(() => {
    if (index === 0)
      return [
        {
          key: "unpin",
          icon: <IoClose size={16} />,
          label: languageMap?.["conversation.message.unpin"] ?? "Unpin",
        },
      ];

    return [
      {
        key: "unpin",
        icon: <IoClose size={16} />,
        label: languageMap?.["conversation.message.unpin"] ?? "Unpin",
      },
      {
        key: "promote",
        icon: <TbArrowBigUpLines size={16} />,
        label: languageMap?.["conversation.message.pinToTop"] ?? "Pin to top",
      },
    ];
  }, [index]);

  if (isNotice) return;

  if (showAllPin || pinnedMessages?.length === 1)
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown
          menu={{
            items: dropDownItemList,
            onClick: onMenuClick,
          }}
          trigger={["click"]}
          placement="leftTop"
        >
          <Button
            type="text"
            size="small"
            icon={<IoIosMore />}
            className="!bg-white hover:!bg-white active:!bg-white !shadow rounded-full border border-gray"
          />
        </Dropdown>
      </div>
    );

  return (
    <div className="flex justify-end absolute right-[20px]">
      <button
        onClick={() => setShowAllPin(!showAllPin)}
        className="
                flex items-center gap-1 text-xs text-blue-500 transition
                border border-gray-300 px-2 py-1
                hover:bg-[#f2f6ff]
              "
      >
        + {pinnedMessages?.length} pin
        <IoChevronDown size={15} />
      </button>
    </div>
  );
};

const PinnedMessageModal = ({ heightHeader }) => {
  const { isMessageSearch } = useMenuContext();
  const {
    pinnedMessages,
    setPinnedMessages,
    jumpToMessage,
    showAllPin,
    setShowAllPin,
  } = useChatContext();
  const [isLoadingOnPin, setIsLoadingOnPin] = useState(false);
  const { languageMap } = useInfoUser();

  const onPromote = async (pinnedMessage) => {
    setIsLoadingOnPin(true);

    const updatedData = [...pinnedMessages];
    const index = updatedData.findIndex(
      (item) => item?.messageId === pinnedMessage?.messageId,
    );

    if (index > -1) {
      const [promoted] = updatedData.splice(index, 1);
      promoted._animated = true;
      promoted.highlighted = true;

      updatedData.unshift(promoted);
      setPinnedMessages(updatedData);

      setTimeout(() => {
        promoted._animated = false;
        promoted.highlighted = false;
        setPinnedMessages([...updatedData]);
      }, 200);
    }

    try {
      const result = await apiFactory.messageApi.promotePinnedMessage({
        conversationId: pinnedMessage?.conversationId,
        messageId: pinnedMessage?.messageId,
      });
      if (result?.status === 200) {
        // setShowAllPin(false);
      } else {
        openNotificationError(
          "Failed to promote the message. Please try again.",
        );
      }
    } catch (error) {
      console.error("Promote failed: ", error);
      openNotificationError("An error occurred while promoting the message.");
    } finally {
      setIsLoadingOnPin(false);
    }
  };

  const unPinMessage = async (message) => {
    pinnedMessage(message, setIsLoadingOnPin);
    if (pinnedMessages?.length === 2) {
      setShowAllPin(false);
    }
  };

  useEffect(() => {
    setPinnedMessages(pinnedMessages);
    setIsLoadingOnPin(false);
  }, [pinnedMessages]);

  if (!pinnedMessages?.length) return null;

  return (
    <div
      className={` absolute left-[0] mt-[-10px] right-[0] ${showAllPin && pinnedMessages?.length > 1 && " z-[100] bg-[#0000008c] h-[100vh] transition-all duration-200 ease"} `}
      style={{
        top: `${heightHeader + 25}px`,
      }}
      onClick={() => setShowAllPin(!showAllPin)}
    >
      {!isMessageSearch && (
        <div
          className={`${showAllPin && pinnedMessages?.length > 1 && "overlay"} absolute top-[5px] left-[4px] right-[4px] z-[100] bg-white rounded-md shadow space-y-2 overflow-hidden`}
        >
          {showAllPin && pinnedMessages?.length > 1 && (
            <div className="flex items-center justify-between bg-[#ebecf0] p-1 px-3">
              <div className="font-medium text-sm">
                Pinbroad ({pinnedMessages?.length})
              </div>
              <div className="flex justify-end">
                <button
                  onClick={() => setShowAllPin(!showAllPin)}
                  className="flex items-center gap-1 text-xs text-blue-600 transition "
                >
                  {showAllPin ? (
                    <>
                      {languageMap?.["conversation.message.showLess"] ??
                        "Show less"}
                      <IoChevronUp size={15} />
                    </>
                  ) : (
                    <>
                      {languageMap?.["conversation.message.seeAll"] ??
                        "See all"}
                      ({pinnedMessages?.length})
                      <IoChevronDown size={15} />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          {pinnedMessages?.map((pinData, index) => {
            return (
              <PinnedMessage
                pinData={pinData}
                index={index}
                isFirst={index === 0}
                onPromote={onPromote}
                unPinMessage={unPinMessage}
                isLoadingOnPin={isLoadingOnPin}
                jumpToMessage={jumpToMessage}
                pinnedMessages={pinnedMessages}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

const PinnedMessage = ({
  pinData,
  index,
  onPromote,
  unPinMessage,
  jumpToMessage,
  isNotice,
}) => {
  const { languageMap } = useInfoUser();

  const { setShowAllPin, showAllPin } = useChatContext();

  if (!showAllPin && index !== 0 && !isNotice) return;

  return (
    <div
      key={index}
      className={`flex items-center h-[50px] px-3 !mt-0 ${showAllPin && "hover:bg-[#f2f6ff]"} border-b transition relative`}
    >
      <RxDrawingPinFilled className="text-blue-600 shrink-0 m-auto" size={18} />

      <div
        onClick={(e) => {
          e.stopPropagation();
          setShowAllPin(false);
          jumpToMessage(pinData);
        }}
        className="ml-3 cursor-pointer flex-1 overflow-hidden"
      >
        <div className=" font-medium text-[12px] text-gray-700 truncate">
          <span className="">{pinData?.pinnedByName}</span>
          <span className="ml-[2px] text-gray-700">
            {languageMap?.["conversation.message.pinned"] ?? "pinned:"}
          </span>
        </div>
        <PinContent pinData={pinData} />
      </div>
      <PinAction
        index={index}
        pinData={pinData}
        onPromote={onPromote}
        unPinMessage={unPinMessage}
        isNotice={isNotice}
      />
    </div>
  );
};

export { PinnedMessageModal, PinnedMessage };
